import { render, staticRenderFns } from "./addstudy.vue?vue&type=template&id=f5802ef8&scoped=true&"
import script from "./addstudy.vue?vue&type=script&lang=js&"
export * from "./addstudy.vue?vue&type=script&lang=js&"
import style0 from "./addstudy.vue?vue&type=style&index=0&id=f5802ef8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5802ef8",
  null
  
)

export default component.exports